import { render, staticRenderFns } from "./Unilateral-static.vue?vue&type=template&id=3635ff13&"
import script from "./Unilateral-static.vue?vue&type=script&lang=js&"
export * from "./Unilateral-static.vue?vue&type=script&lang=js&"
import style0 from "./Unilateral-static.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports